import { gql } from '@apollo/client';

export const UPDATE_USER = gql`
  mutation Flex_UpdateUserMetaData($id: Int!, $input: UpdateUserInput!) {
    updateUser(id: $id, input: $input) {
      id
    }
  }
`;
